"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _EotcBuySellCustomRowComponent = _interopRequireDefault(require("./EotcBuySellCustomRowComponent"));
var _buySellSelectors = require("../../../../../redux/selectors/buySellSelectors");
var _orderEntryActions = require("../../../../../redux/actions/orderEntryActions");
var _instrumentPositionSelectors = require("../../../../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var selector = (0, _reduxForm.formValueSelector)('buySell');
var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;
  var formObj = form.buySell || {
    values: {}
  };
  var decimalPlaces = state.apexCore.product.decimalPlaces;
  var _getQuantityDataForPr = (0, _buySellSelectors.getQuantityDataForPresetAndCustomValuesSelector)(state, formObj.values.side, formObj.values.quantity),
    _getQuantityDataForPr2 = _slicedToArray(_getQuantityDataForPr, 1),
    customValues = _getQuantityDataForPr2[0];
  var isBuySide = (0, _buySellSelectors.isBuySideBuySellFormSelector)(state);
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  return {
    isBuySide: isBuySide,
    selectedInstrument: selectedInstrument,
    decimalPlaces: decimalPlaces,
    customValues: customValues,
    formObj: formObj,
    activeAmount: selector(state, 'amountRadio')
  };
};
var mapDispatchToProps = {
  synchronizePriceWithQuantity: _orderEntryActions.synchronizePriceWithQuantity,
  setAmount: function setAmount(amount) {
    return (0, _reduxForm.change)('buySell', 'amountRadio', amount);
  }
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EotcBuySellCustomRowComponent["default"]);